import React, { useState, useEffect } from "react";
import { Link, useParams, useLocation } from "react-router-dom";
import "./howUseLiveMatrix.css";
import "react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader
import API from "../../../utils/apiCalling";
import { config } from "../../../utils/apiUrl";
import { Carousel } from "react-responsive-carousel";
import {Base_Url} from "../../../utils/apiUrl"

import DataLayout from "./DataLayout";

import Guest1 from "./Guest/Guest1";
import Guest2 from "./Guest/Guest2";
import Guest3 from "./Guest/Guest3";
import Guest4 from "./Guest/Guest4";
import Guest5 from "./Guest/Guest5";
import Guest6 from "./Guest/Guest6";
import Sharebtn from "../../../components/common/layout/ShareBtn";

const HowUseLiveMatrixs = (props) => {
  const api = new API();
  const { title,id ,index} = useParams();
  const [allVideoData, setAllVideoData] = useState([])
  const [videoData, setVideoData] = useState({})
  const [pageIndex, setPageIndex] = useState(index)
   const getWarrantVideos = async () => {
        let WarrantSearchResult = await api.get(config.VideoWarrants, true);
        let dataArr = WarrantSearchResult.filter((v,i)=>{
          return v.title == title
        })
        setAllVideoData(dataArr[0].videos)
        setVideoData(dataArr[0].videos[index])
    };
  useEffect(() => {
    getWarrantVideos()
  }, []);

  const changeVideo=(value)=> {
    if (value == 'next') {
        var index = Number(pageIndex) + 1;
    } else {
        var index = Number(pageIndex) - 1;
    }
    var dataList = allVideoData[index];
    setPageIndex(index)
    setVideoData(dataList)
}
  const srcLink = "https://www.youtube.com/embed/" + videoData.playlist_id + "?autoplay=" + 0 + "&index=" + videoData.index + "&rel=0&wmode=opaque";
  var text = videoData.title;
  var p = videoData.text;
  var pHtml = { __html: p };
  var textHtml = { __html: text };
  return (
    <div id="dwvideoind" className="pageobj educational_warrent" style={{}}>
      <div className="breadcrumbbar">
        <div className="container-fluid">
          <ol className="breadcrumb">
            <li>
              <Link to="/home?edu">Warrant education</Link>
            </li>
            <li>
              <Link to="/education/warrantvideosind">Warrant videos</Link>
            </li>
            <li className="active">{title}</li>
          </ol>
        </div>
      </div>
      <div className="stripe-bg" />
      <div className="container-fluid">
        <div className="section">
          <div className="page-header">
            <h1>{title}</h1>
          </div>
          <div id="video-anchor" className="video-anchor" />
          <div className="videoplayer">
            <div className="videoplayer-container">
              <iframe
                frameBorder={0}
                allowFullScreen
                allow="autoplay"
                src={srcLink}
              />
              <div className='slick-prev slick-arrow'>
                  <img src="/img/education/arrow2.png" style={{ display: pageIndex == 0 ? 'none' : 'block' }} alt="" className='preImg' onClick={() => { changeVideo('pre') }} />
              </div>
              <div className='slick-next slick-arrow'>
                  <img src="/img/education/arrow2.png" style={{ display: pageIndex == allVideoData.length - 1 ? 'none' : 'block' }} alt="" className='nextImg' onClick={() => { changeVideo('next') }} />
              </div>
            </div>
          </div>
          <div className="videoinfo">
              <div className="videoinfo-title" dangerouslySetInnerHTML={textHtml}></div>
              <p className="videoinfo-p" dangerouslySetInnerHTML={pHtml}></p>
              <Link
                  to={{
                      pathname:
                          "https://www.facebook.com/login.php?skip_api_login=1&api_key=966242223397117&signed_next=1&next=https%3A%2F%2Fwww.facebook.com%2Fshare.php%3Fu%3Dhttps%253A%252F%252Ft1www5.trkd-hs.com%252Fmqmy_aws%252Feducation%252Fwarrantvideosind%253Flang%253Den%2526playlistId%253DPLOkzCdnS95xTdMhV0ItxdWqpa2ji_BVB3%2526index%253D5&cancel_url=https%3A%2F%2Fwww.facebook.com%2Fdialog%2Fclose_window%2F%3Fapp_id%3D966242223397117%26connect%3D0%23_%3D_&display=popup&locale=en_GB",
                  }}
                  target="_blank"
              >
                  <div className="fbSharebtn"><i className="fa fa-facebook" aria-hidden="true"></i>Share on Facebook</div>
              </Link>
          </div>
        </div>
      </div>
    </div>
  );
};
export default HowUseLiveMatrixs;
